export default "__VITE_ASSET__DKcUBUPz__"